import { useTranslation } from 'react-i18next';

import { NOTIFICATION_TYPE_CONFIG } from '../../constants/notification-type-config';
import { Notification } from '../../types';
import { NotificationItemShell } from './notification-item-shell';

interface NotificationItemDefaultProps {
  notification: Notification;
  onMarkAsRead?: (notificationId: number) => void;
  onDelete?: (notificationId: number) => void;
}

/**
 * Default notification item component.
 * Uses type-based i18n rendering from NOTIFICATION_TYPE_CONFIG.
 * Navigates to the action URL on click if available.
 */
export function NotificationItemDefault({
  notification,
  onMarkAsRead,
  onDelete,
}: NotificationItemDefaultProps) {
  const { t } = useTranslation('authenticated.notifications');

  const typeConfig = NOTIFICATION_TYPE_CONFIG[notification.type];
  const actionUrl = typeConfig?.getActionUrl
    ? typeConfig.getActionUrl(notification.actionArgs ?? {})
    : null;

  const title = typeConfig ? t(typeConfig.titleKey, notification.args ?? {}) : '';
  const description = typeConfig ? t(typeConfig.descriptionKey, notification.args ?? {}) : '';

  return (
    <NotificationItemShell
      notification={notification}
      title={title}
      actionUrl={actionUrl}
      onMarkAsRead={onMarkAsRead}
      onDelete={onDelete}
    >
      <p className="whitespace-pre-line text-sm leading-snug text-muted-foreground">
        {description}
      </p>
    </NotificationItemShell>
  );
}
